import component from './WidgetCode.vue'
export default component
